import { useState } from "react";
import { useModal } from "../useModal";
import { AuthFetchTGUIO } from "../../services/api";
import { notify } from "../../utils/utils";


export const useEnlaceGruposUID = () => {
    const usuarioUIdDefault ={
        UID:0,
        codRuta: "0",
        favorito: false,
        chat: true,
        IdRoom: "",
        codEmpresa: 0,
        CodGrupoDetalle: 0,
        Pertenece: false
    }
    const [ isOpenModalRegistrarEnlace, openModalRegistrarEnlace, closeModalRegistrarEnlace ] = useModal(null);
    const [ usuarioGrupos, setUsuarioGrupos ] = useState([]);
    const [ usuarioGrupo, setUsuarioGrupo ] = useState(usuarioUIdDefault);
    const [ loading, setLoading ] = useState(false);


    const listarUsuariosPorGrupo = async (codGrupo) => {
        try{
            setLoading(true)
            const response = await AuthFetchTGUIO(`/chat-groups/${codGrupo}/uid`)
            !response.isValid && notify(response.exceptions[0].description,'error');
            setUsuarioGrupos(response.isValid ? response.content : []);
        }
        catch(error){
            setUsuarioGrupos([]);
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar -> ',error);
        }
        setLoading(false);
    }

    const guardarEditarEnlaceGrupo = async (uid,idRoom,chat) => {
        try{
            const response = await AuthFetchTGUIO('/chat-groups/uid',{
                method: 'PATCH',
                body: JSON.stringify({
                    UID: uid,
                    codRuta: usuarioGrupo.codRuta,
                    favorito: usuarioGrupo.favorito,
                    chat: chat,
                    idRoom: idRoom

                }),
            })
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
            return response.isValid
        }
        catch(error){

        }
    }

    const obtenerDatosUID = async (data) => {
        if(data){
            editarValorUIDGrupo("UID",data.UID);
            editarValorUIDGrupo("codEmpresa",0);
            editarValorUIDGrupo("CodGrupoDetalle",data.CodGrupoDetalle);
        }
        else{
            setUsuarioGrupo(usuarioUIdDefault)
        }
    }

    const editarValorUIDGrupo = (key,value) => {
        console.log('key ',key, ' value ',value)
        setUsuarioGrupo(usuarioGrupo => {
            return {
                ...usuarioGrupo,
                [key]: value
            }
        });
    }

    return{
        usuarioGrupos,
        usuarioGrupo,
        listarUsuariosPorGrupo,
        guardarEditarEnlaceGrupo,
        obtenerDatosUID,
        editarValorUIDGrupo,
        isOpenModalRegistrarEnlace,
        openModalRegistrarEnlace,
        closeModalRegistrarEnlace,
        loading
    }
}